export default "/images/vendor/flag-icon-css/flags/4x3/sc.svg?9ef5262cc695adcc613f8d19bdc030df";